import styled from 'styled-components'
// @ts-ignore
import Select from 'react-select'
import { colors, device } from 'Styled/variables'

export const StyledSelect = styled(Select)`
  .language-select {
    &__input {
      color: #646877 !important;
    }
    &__value-container {
      &--has-value {
        padding: 1px !important;
      }
    }
    &__control {
      min-height: 48px !important;
      outline: none !important;
      box-shadow: none !important;
      border: 1px solid ${colors.greyStroke} !important;
      margin-bottom: 12px !important;
      color: #646877 !important;
    }
    &__placeholder {
      margin-left: 8px !important;
      color: #999999 !important;
      line-height: 21px !important;
    }
  }

  .language-select__multi-value {
    color: #1cb954 !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    height: 90%;
    background-color: rgba(28, 185, 84, 0.15) !important;
    padding: 5px 5px 5px 6px !important;
    line-height: 21px;
    animation: fadeIn 0.5s ease-in-out;
  }

  .language-select__multi-value__label {
    color: #1cb954 !important;
    font-size: 14px;
    font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  }

  .language-select__clear-indicator {
    display: none !important;
  }

  .language-select__indicator-separator {
    display: none !important;
  }

  .language-select__menu {
    padding: 8px 4px 8px 16px;
    filter: drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.25));
    border-radius: 8px !important;
    position: relative !important;
    border: none;
  }

  .language-select__dropdown-indicator {
    display: none;
  }

  .language-select__option {
    border-bottom: 1px solid #f3f4f7;
    font-size: 14px;
    padding: 13px 0;
    cursor: pointer;
  }

  .language-select__multi-value__remove {
    font-weight: 200 !important;
    background-position: center center;
    padding: 15px;
    & svg {
      display: none !important;
    }
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath opacity='0.5' d='M5.91615 4.99995L9.80995 1.10605C10.0634 0.852766 10.0634 0.443244 9.80995 0.189962C9.55667 -0.0633206 9.14714 -0.0633206 8.89386 0.189962L4.99994 4.08387L1.10614 0.189962C0.85274 -0.0633206 0.443335 -0.0633206 0.190051 0.189962C-0.0633505 0.443244 -0.0633505 0.852766 0.190051 1.10605L4.08385 4.99995L0.190051 8.89386C-0.0633505 9.14714 -0.0633505 9.55666 0.190051 9.80994C0.316278 9.93629 0.482246 9.99976 0.648097 9.99976C0.813947 9.99976 0.979797 9.93629 1.10614 9.80994L4.99994 5.91604L8.89386 9.80994C9.0202 9.93629 9.18605 9.99976 9.3519 9.99976C9.51775 9.99976 9.6836 9.93629 9.80995 9.80994C10.0634 9.55666 10.0634 9.14714 9.80995 8.89386L5.91615 4.99995Z' fill='%231CB954'/%3e%3c/svg%3e");
  }
  .genres {
    &__input {
      color: #646877 !important;
    }
    &__value-container {
      &--has-value {
        padding: 1px !important;
      }
    }
    &__control {
      min-height: 48px !important;
      outline: none !important;
      box-shadow: none !important;
      border: none !important;
      margin-bottom: 12px !important;
      color: #646877 !important;
    }
    &__placeholder {
      margin-left: 8px !important;
      color: #999999 !important;
      line-height: 21px !important;
    }
  }

  .genres__multi-value {
    color: #1cb954 !important;
    border-radius: 4px !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    height: 90%;
    background-color: rgba(28, 185, 84, 0.15) !important;
    padding: 5px 5px 5px 6px !important;
    line-height: 21px;
    animation: fadeIn 0.5s ease-in-out;
  }

  .genres__multi-value__label {
    color: #1cb954 !important;
    font-size: 14px;
    font-family: 'Segoe UI', 'Roboto', sans-serif !important;
  }

  .genres__clear-indicator {
    display: none !important;
  }

  .genres__indicator-separator {
    display: none !important;
  }

  .genres__menu {
    padding: 8px 4px 8px 16px;
    filter: drop-shadow(0px 0px 6px rgba(0, 0, 0, 0.25));
    border-radius: 8px !important;
    position: relative !important;
    border: none;
  }

  .genres__dropdown-indicator {
    display: none;
  }

  .genres__option {
    border-bottom: 1px solid #f3f4f7;
    font-size: 14px;
    padding: 13px 0;
    cursor: pointer;
  }

  .genres__multi-value__remove {
    cursor: pointer;
    font-weight: 200 !important;
    background-position: center center;
    padding: 15px;
    & svg {
      display: none !important;
    }
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath opacity='0.5' d='M5.91615 4.99995L9.80995 1.10605C10.0634 0.852766 10.0634 0.443244 9.80995 0.189962C9.55667 -0.0633206 9.14714 -0.0633206 8.89386 0.189962L4.99994 4.08387L1.10614 0.189962C0.85274 -0.0633206 0.443335 -0.0633206 0.190051 0.189962C-0.0633505 0.443244 -0.0633505 0.852766 0.190051 1.10605L4.08385 4.99995L0.190051 8.89386C-0.0633505 9.14714 -0.0633505 9.55666 0.190051 9.80994C0.316278 9.93629 0.482246 9.99976 0.648097 9.99976C0.813947 9.99976 0.979797 9.93629 1.10614 9.80994L4.99994 5.91604L8.89386 9.80994C9.0202 9.93629 9.18605 9.99976 9.3519 9.99976C9.51775 9.99976 9.6836 9.93629 9.80995 9.80994C10.0634 9.55666 10.0634 9.14714 9.80995 8.89386L5.91615 4.99995Z' fill='%231CB954'/%3e%3c/svg%3e");
  }
`

export const SuccessContainer = styled.div<{ mobile?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px;
  padding-top: ${({ mobile }) => (mobile ? '70px' : '30px')};
  flex-direction: ${({ mobile }) => (mobile ? 'column' : 'row')};
`

export const SuccessContainerMobile = styled.div`
  flex: 1;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${colors.white};
`

export const SuccessText = styled.p`
  font-size: 18px;
  color: ${colors.mainText};
`

export const SuccessIcon = styled.img<{ mobile?: boolean }>`
  margin-right: 16px;
  margin-bottom: ${({ mobile }) => (mobile ? '16px' : '0px')};
  width: 40px;
  height: 40px;
`
export const SuccessButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0 48px;
`

export const PageTitleRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 30px;
`

export const PageTitle = styled.h4`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const BackButton = styled.img`
  margin-right: 12px;
  padding: 5px;
  width: 22px;
  height: 20px;
`

export const ContentBlock = styled.div<{ last?: boolean }>`
  margin-bottom: ${({ last }) => (last ? 112 : 10)}px;
  padding: 24px 16px;
  background-color: ${colors.white};
  border-radius: 4px;
`

export const MobileButtonContainer = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 72px;
  background-color: ${colors.white};
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.3);
`

export const IrrelevantContainer = styled.div`
  padding: 24px 48px 48px;

  @media ${device.mobileMax} {
    padding: 0 0 0 24px;
  }
`

export const IrrelevantTitleRow = styled.div`
  position: relative;
  left: -24px;
  display: flex;
  align-items: center;
  margin-bottom: 18px;

  @media ${device.mobileMax} {
    align-items: flex-start;
  }
`

export const IrrelevantIcon = styled.img`
  margin-right: 8px;
  width: 16px;
  height: 16px;
`

export const IrrelevantTitleText = styled.span`
  color: ${colors.messegesRed};
`

export const IrrelevantDescription = styled.span`
  color: ${colors.mainText};
`

export const IrrelevantDescriptionUnderline = styled.a`
  color: ${colors.mainText};
  border-bottom: 1px dashed ${colors.mainText};

  &:visited {
    color: ${colors.mainText};
  }
`
export const AlertWrapper = styled.div<{ success?: boolean }>`
  padding-left: 25px;
  padding-right: 24px;
  margin-bottom: ${({ success }) => (success ? 40 : 0)}px;
`
export const AlertText = styled.div<{ success?: boolean }>`
  margin-bottom: 9px;
  display: flex;
  flex-direction: column;
  color: ${({ success }) => (success ? colors.green : colors.messegesYellow1)};
`
